import { ApplicationElement, html } from '../application_element/element.js';
import { ifDefined } from 'lit/directives/if-defined.js';

import '../avatar/element.js';
import style from './style.lit.css';

/**
 * List item containing rounded avatar and link to the member
 *
 * @prop href - String
 * @prop first_name - String
 * @prop last_name - String
 * @prop picture - String ( optional )
 * @prop layout - String, if true, renders name (options: -, big)
 */
export default class NewMember extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    href: { type: String },
    first_name: { type: String },
    last_name: { type: String },
    picture: { type: String },
    layout: { type: String },
  };

  get fullName() {
    const { first_name, last_name } = this;
    return first_name || last_name
      ? [first_name, last_name].filter(Boolean).join(' ')
      : undefined;
  }

  get isBig() {
    return this.layout === 'big';
  }

  render() {
    return html`
      <a href=${this.href}>
        <ef-avatar
          picture=${ifDefined(this.picture)}
          name=${ifDefined(this.fullName)}
          rounded>
        </ef-avatar>

        ${this.isBig
          ? html`
              <h4 class="title">
                <div>${this.first_name}</div>
                <div>${this.last_name}</div>
              </h4>
            `
          : null}
      </a>
    `;
  }
}

customElements.get('ef-new-member') ||
  customElements.define('ef-new-member', NewMember);
